import axios from '../axios';

export default {
  getClients (options) {
    const params = {};

    if (options.pagination) {
      params.pagination = 1;
    }

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.sort) {
      params.sort = options.sort;
    }

    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    if (options.include && options.include.length) {
      params.include = options.include.join();
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/client?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  getClient (id, options) {
    const params = {};

    if (options.include && options.include.length) {
      params.include = options.include.join();
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get(`/client/${id}?` + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  newClient (params) {
    return new Promise((resolve, reject) => {
      axios.post('/client', params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  updateClient (data) {
    return new Promise((resolve, reject) => {
      axios.put(`/client/${data.id}`, { ...data })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  exportCsv () {
    return new Promise((resolve, reject) => {
      axios.get('/client/export-csv', { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  deleteClient (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/client/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  addClientAbonent (client, abonent) {
    return new Promise((resolve, reject) => {
      axios.post(`/client/${client}/abonent/${abonent}/add`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  getCarNumberChangesHistory (params = {}) {
    const queryParams = new URLSearchParams();
    if (params.client_id != null) queryParams.append('client_id', params.client_id);
    if (params.date_from) queryParams.append('date_from', params.date_from);
    if (params.date_to) queryParams.append('date_to', params.date_to);
    if (params.barrier_id != null) queryParams.append('barrier_id', params.barrier_id);
    if (params.action_type) queryParams.append('action_type', params.action_type);
    if (params.per_page != null) queryParams.append('per_page', params.per_page);
    if (params.page != null) queryParams.append('page', params.page);
    const query = queryParams.toString();
    return new Promise((resolve, reject) => {
      axios.get(`/client/car-number-changes-history${query ? '?' + query : ''}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  getGuestAccessHistory (params = {}) {
    const queryParams = new URLSearchParams();
    if (params.client_id != null) queryParams.append('client_id', params.client_id);
    if (params.date_from) queryParams.append('date_from', params.date_from);
    if (params.date_to) queryParams.append('date_to', params.date_to);
    if (params.barrier_id != null) queryParams.append('barrier_id', params.barrier_id);
    if (params.include_deleted !== undefined) queryParams.append('include_deleted', params.include_deleted ? '1' : '0');
    if (params.per_page != null) queryParams.append('per_page', params.per_page);
    if (params.page != null) queryParams.append('page', params.page);
    const query = queryParams.toString();
    return new Promise((resolve, reject) => {
      axios.get(`/client/guest-access-history${query ? '?' + query : ''}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  activateCarNumber (clientId, { car_number_id, barrier_ids }) {
    return new Promise((resolve, reject) => {
      axios.post(`/client/${clientId}/car-number/activate`, { car_number_id, barrier_ids })
        .then((response) => resolve(response))
        .catch(error => reject(error));
    });
  },

  /**
   * Поиск по гос. номеру
   * @param {string} carNumber
   * @returns {Promise<{ data: object }>}
   */
  getCarNumberSearch (carNumber) {
    const params = new URLSearchParams();
    if (carNumber && carNumber.trim()) {
      params.append('car_number', carNumber.trim());
    }
    const query = params.toString();
    return new Promise((resolve, reject) => {
      axios.get(`/client/car-number-search${query ? `?${query}` : ''}`)
        .then((response) => resolve(response))
        .catch(error => reject(error));
    });
  },
};
